import controller from './selector.controller';

const template = require('./selector.html');

export default {
    bindings: {
        preSelected: '<',
        selected: '=?fsModel',
        multiSelect: '<',
        expandSelected: '=',
        onChange: '&'
    },
    controller,
    template
};



// WEBPACK FOOTER //
// ./app/common/tree/folder-selector/selector.component.js